(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elyssence-how-to"] && !Shopify.designMode) return;
  try {
    
  const initElyssenceGuideVideos = (root = document) => {
    root.querySelectorAll('.elyssence-guides:not([data-video-ready])').forEach((section) => {
      const modal = section.querySelector('[data-guide-modal]');
      const frame = section.querySelector('[data-guide-modal-frame]');
      const closeButton = section.querySelector('[data-guide-modal-close]');

      if (!modal || !frame || !closeButton) return;
      section.dataset.videoReady = 'true';

      const closeVideo = () => {
        if (modal.open) modal.close();
        frame.src = '';
      };

      section.querySelectorAll('[data-guide-video]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const videoId = trigger.dataset.videoId;
          if (!videoId) return;
          frame.title = trigger.dataset.videoTitle || '';
          frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          modal.showModal();
        });
      });

      closeButton.addEventListener('click', closeVideo);
      modal.addEventListener('close', () => { frame.src = ''; });
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeVideo();
      });
    });
  };

  initElyssenceGuideVideos();
  document.addEventListener('shopify:section:load', (event) => initElyssenceGuideVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
